import { Instance, types } from 'mobx-state-tree'
import { capitalize } from '@mui/material'
import { DateTime } from 'luxon'

export const SubscriptionPurchase = types
  .model('SubscriptionPurchase')
  .props({
    id: types.identifierNumber,
    purchase_succeeded: types.boolean,
    source: types.enumeration(['purchase', 'direct', 'test']),
    customer_id: types.maybeNull(types.string),
    color: types.maybeNull(types.string),
    customer_email: types.optional(types.string, ''),
    product_title: types.string,
    product_id: types.number,
    purchase_date: types.maybe(types.maybeNull(types.string)),
    receipt: types.maybeNull(types.string),
    user: types.maybeNull(types.string),
    user_id: types.optional(types.number, 0),
    photo_url: types.maybeNull(types.string),
    transaction_id: types.string,
    transaction_type: types.optional(types.string, ''),
    expiration_date: types.maybeNull(types.string),
    tags: types.optional(types.array(types.frozen()), []),
    product_content: types.optional(types.array(types.frozen()), []),
    title: types.optional(types.string, ''),
    description: types.maybeNull(types.string),
    tag_ids: types.maybeNull(types.array(types.integer)),
  })
  .views((self) => ({
    get isFailed() {
      return !self.purchase_succeeded
    },
    get isActive() {
      if (!self.expiration_date) return true
      return DateTime.fromISO(self.expiration_date) > DateTime.now()
    },
    get isExpired() {
      if (!self.expiration_date) return false
      return DateTime.fromISO(self.expiration_date) < DateTime.now()
    },
    get isExpiring() {
      if (!self.expiration_date) return false
      const expiration = DateTime.fromISO(self.expiration_date)
      const now = DateTime.now()
      return expiration > now && expiration <= now.plus({ days: 7 })
    },
    get isTest() {
      return self.source === 'test'
    },
    get status() {
      if (this.isFailed) {
        return 'failed'
      } else if (this.isExpired) {
        return 'expired'
      } else if (this.isExpiring) {
        return 'expiring'
      } else {
        return 'active'
      }
    },
    get purchaseDateDisplay() {
      return self.purchase_date
        ? DateTime.fromISO(self.purchase_date).toLocaleString(DateTime.DATETIME_MED)
        : ''
    },
    get sourceDisplay() {
      return capitalize(self.source)
    },
    get displayName() {
      return self.user || self.customer_email || ''
    },
  }))

export type SubscriptionPurchaseType = Instance<typeof SubscriptionPurchase>
